import { render, staticRenderFns } from "./trainingOrderDetail.vue?vue&type=template&id=3c4d5ab8&scoped=true&"
import script from "./trainingOrderDetail.vue?vue&type=script&lang=js&"
export * from "./trainingOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./trainingOrderDetail.vue?vue&type=style&index=0&id=3c4d5ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d5ab8",
  null
  
)

export default component.exports